import WithoutColorSection from './without-color-section';
export default WithoutColorSection;
